var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:_vm.innerClass,attrs:{"fluid":""}},[_c('v-switch',{class:_vm.innerClass,attrs:{"readonly":_vm.readOnly,"disabled":_vm.disabled,"input-value":_vm.val,"label":_vm.innerLabel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }